import { useMemo } from 'react';
import { ItemList } from '../item-list';
import { ButtonConfig, ButtonProps, Context } from './types';
import { ButtonForm } from './ButtonForm';

export function ReplyButtons({ context }: { context: Context; }) {
  const rawItems = (context as any).props.config.buttons || [];

  const items = useMemo(() => parseButtons(rawItems), [rawItems]);

  const saveChanges = (items: ButtonConfig[]) => {
    context.setConfig('buttons', items);
    context.saveChanges('buttons', items);
  };

  return (
    <ItemList
      context={context}
      items={items}
      Items={Buttons as any}
      ItemForm={ButtonForm as any}
      onSave={saveChanges as any}
    />
  );
}

function parseButtons(buttons: ButtonConfig[]): ButtonConfig[] {
  return (
    buttons?.map((button, i) => {
      return {
        ...button,
        id: i + 1,
        title:
          window.apm.serialized.components.intents.find(
            (int) => int.id === button.intent
          )?.name || ''
      };
    }) || []
  );
}

function Buttons({ items, onClick, active, styles = {} }: ButtonProps) {
  return (
    <ul className={styles.list}>
      {items.map(({ id, label, url, title, urlType }) => {
        return (
          <li key={id} onClick={() => onClick(id)} className={active === id ? styles.active : ''}>
            <div className={styles.mainPanel}>
              <h4>{title}</h4>
              <MultiField {...label} />
              <div className={styles.textLine}>
                <i className={'fe icon-link-2'} /> type: {urlType}
              </div>
              <div className={styles.textLine}>
                <i className={'fe icon-link-2'} /> url: {url}
              </div>
            </div>
            <div className={styles.sidePanel}>
              <i className={'fe icon-edit-3'}></i>
            </div>
          </li>
        );
      })}
    </ul>
  );
}

function MultiField(labels: Record<string, string>) {
  return (
    <div>
      {Object.entries(labels).map(([key, value]) => (
        <div key={key}>
          <i className={'fe icon-hash'} /> {key}: {value}
        </div>
      ))}
    </div>
  );
}
